import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {RoleGuard} from '@services/role.guard';
import {ShipmentsComponent} from "@modules/shipments/shipments.component";
import {SavedShipmentsComponent} from "@modules/shipments/components/saved-shipments/saved-shipments.component";
import {BookedShipmentsComponent} from "@modules/shipments/components/booked-shipments/booked-shipments.component";
import {OngoingShipmentsComponent} from "@modules/shipments/components/ongoing-shipments/ongoing-shipments.component";
import {DeliveredShipmentsComponent} from "@modules/shipments/components/delivered-shipments/delivered-shipments.component";
import {ShipmentInfoComponent} from '@modules/shipments/components/shipment-info/shipment-info.component.ts';
import {ShipmentListComponent} from "@modules/shipments/components/shipments-list/shipment-list.component";
import { ShipmentImportComponent } from '@modules/shipments/components/shipment-import/shipment-import.component';
import { TrackResolve } from '@services/track.resolve';
import { TrackComponent } from '@modules/shipments/components/track/track.component';

const route: Routes = [
  {
    path: 'shipments',
    component: ShipmentsComponent,
    canActivate: [RoleGuard],
    data: {expectedRole: '2'},
    children: [
      {
        path: '',
        redirectTo: '/saved',
        pathMatch: 'full'
      },
      {
        path: 'saved',
        component: ShipmentListComponent,
      },
      {
        path: 'booked', children: [
          {path: '', component: ShipmentListComponent},
          {path: ':id', component: ShipmentInfoComponent, data: {route: 'booked'}},
        ]
      },
      {
        path: 'ongoing', children: [
          {path: '', component: ShipmentListComponent},
          {path: ':id', component: ShipmentInfoComponent, data: {route: 'ongoing'}},
        ]
      },
      {
        path: 'delivered', children: [
          {path: '', component: ShipmentListComponent},
          {path: ':id', component: ShipmentInfoComponent, data: {route: 'delivered'}},
        ]
      },
      {
        path: 'import',
        component: ShipmentImportComponent,
      }
    ]
  },
  {
    path: 'track',
    canActivate: [RoleGuard],
    data: {expectedRole: '2'},
    children: [
      {
        path: ':id',
        component: TrackComponent,
        resolve: {
          track: TrackResolve
        }
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(route),
    TranslateModule
  ],
  exports: [
    RouterModule
  ]
})

export class ShipmentsRoutingModule {
}




// WEBPACK FOOTER //
// ./src/app/modules/shipments/shipments-routing.module.ts